<app-modal *ngIf="vo$ | async; let vo">
	<div
		modal-body
		class="app-action-confirm-popup">
		<ng-container [ngSwitch]="vo.action">
			<ng-container *ngSwitchCase="'DELETE_CONSUMER'">
				<!-- alert info -->
				<dc-alert
					*ngIf="!vo.isMultipleElement" type="error" message="info"
					i18n-message="@@subscription.consumedProject.action.confirmation.popup.delete.info"></dc-alert>

				<dc-alert
					*ngIf="vo.isMultipleElement" type="error" message="multiple-info"
					i18n-message="@@subscription.consumedProject.action.confirmation.popup.delete.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-action-confirm-popup__description"
					i18n="@@subscription.consumedProject.action.confirmation.popup.delete.description">
					deletion-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-action-confirm-popup__description"
					i18n="@@subscription.consumedProject.action.confirmation.popup.delete.multiple.description">
					deletion-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="'DEACTIVATE_CONSUMER'">
				<!-- alert info -->
				<dc-alert
					*ngIf="!vo.isMultipleElement" type="warning" message="warn"
					i18n-message="@@subscription.consumedProject.action.confirmation.popup.deactivate.info"></dc-alert>

				<dc-alert
					*ngIf="vo.isMultipleElement" type="warning" message="multiple-warn"
					i18n-message="@@subscription.consumedProject.action.confirmation.popup.deactivate.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-action-confirm-popup__description"
					i18n="@@subscription.consumedProject.action.confirmation.popup.deactivate.description">
					deactivate-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-action-confirm-popup__description"
					i18n="@@subscription.consumedProject.action.confirmation.popup.deactivate.multiple.description">
					deactivate-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="'ACTIVATE_CONSUMER'">
				<!-- alert info -->
				<dc-alert
					*ngIf="!vo.isMultipleElement" type="warning" message="warn"
					i18n-message="@@subscription.consumedProject.action.confirmation.popup.activate.info"></dc-alert>

				<dc-alert
					*ngIf="vo.isMultipleElement" type="warning" message="multiple-warn"
					i18n-message="@@subscription.consumedProject.action.confirmation.popup.activate.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-action-confirm-popup__description"
					i18n="@@subscription.consumedProject.action.confirmation.popup.activate.description">
					activate-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-action-confirm-popup__description"
					i18n="@@subscription.consumedProject.action.confirmation.popup.activate.multiple.description">
					activate-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="'UPDATE_CONSUMER'">
				<!-- alert info -->
				<dc-alert type="warning" message="warn"
					i18n-message="@@subscription.consumedProject.action.confirmation.popup.update.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-action-confirm-popup__description"
					i18n="@@subscription.consumedProject.action.confirmation.popup.update.description">
					update-request</span>
			</ng-container>

		</ng-container>

		<div class="app-action-confirm-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElement">
					concerned-element</span>

				<span class="app-action-confirm-popup__element-label">
					{{ vo.element | truncate: 30: 1 : 'end' }}</span>
			</ng-container>

			<ng-container *ngIf="vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElements">
					concerned-elements</span>

				<div class="app-action-confirm-popup__element-label">
					{{ vo.elementId.length }}
						<span
							i18n="@@subscription.consumedProject.action.confirmation.popup.projects">
							consumed-projects</span>
				</div>
			</ng-container>
		</div>

		<mat-checkbox
			*ngIf="vo.action === 'DELETE_CONSUMER'"
			id="{{ cmpId }}-confirm-delete-checkbox"
			color="primary"
			[(ngModel)]="confirmDeletion">
			<span
				i18n="@@subscription.action.confirmation.popup.delete.confirm">
				confirm-delete</span>
		</mat-checkbox>
	</div>

	<div modal-footer class="app-action-confirm-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="'DELETE_CONSUMER'"
				id="{{ cmpId }}-delete-consumed-project-btn"
				class="app-action-confirm-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.delete.btn">
					delete</span>
			</button>

			<button
				*ngSwitchCase="'DEACTIVATE_CONSUMER'"
				id="{{ cmpId }}-deactivate-consumed-project-btn"
				class="app-action-confirm-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.FlashOff"></mat-icon>
				<span
					i18n="@@subscription.consumedProject.action.confirmation.popup.deactivate.btn">
					deactivate</span>
			</button>

			<button
				*ngSwitchCase="'ACTIVATE_CONSUMER'"
				id="{{ cmpId }}-activate-consumed-project-btn"
				class="app-action-confirm-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Flash"></mat-icon>
				<span
					i18n="@@subscription.consumedProject.action.confirmation.popup.activate.btn">
					activate</span>
			</button>

			<button
				*ngSwitchCase="'UPDATE_CONSUMER'"
				id="{{ cmpId }}-update-consumed-project-btn"
				class="app-action-confirm-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Edit"></mat-icon>
				<span
					i18n="@@subscription.consumedProject.action.confirmation.popup.update.btn">
					update</span>
			</button>

		</ng-container>
	</div>
</app-modal>
